import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApparelReplenishmentService {

  replenishmentGraphSubject = new Subject();

  constructor() { }
}
